import { render, staticRenderFns } from "./anchor.vue?vue&type=template&id=d5c64022&"
import script from "./anchor.vue?vue&type=script&lang=js&"
export * from "./anchor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5c64022')) {
      api.createRecord('d5c64022', component.options)
    } else {
      api.reload('d5c64022', component.options)
    }
    module.hot.accept("./anchor.vue?vue&type=template&id=d5c64022&", function () {
      api.rerender('d5c64022', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/anchor/anchor.vue"
export default component.exports